/* jshint esversion: 6 */

const Visibility = {
    detectProperties() {
        let prefix = "";
        if (typeof document.mozHidden !== "undefined") {
            prefix = "moz";
        } else if (typeof document.msHidden !== "undefined") {
            prefix = "ms";
        } else if (typeof document.webkitHidden !== "undefined") {
            prefix = "webkit";
        }

        if (prefix) {
            return {
                event: `${prefix}visibilitychange`,
                state: `${prefix}VisibilityState`
            };
        } else {
            return {
                event: 'visibilitychange',
                state: 'visibilityState'
            };
        }
    },
    attach(callback) {
        let properties = Visibility.detectProperties();

        document.addEventListener(properties.event, () => {
            callback.apply(null, [document[properties.state]]);
        });
    },
    detach(callback) {
        let properties = Visibility.detectProperties();

        document.removeEventListener(properties.event, callback);
    }
};

export default Visibility;
